// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from '/builds/2hHQnLx3/1/lf/aftersell/intradesk-frontend/node_modules/.pnpm/@umijs+renderer-react@4.7.8_react-dom@18.3.1_react@18.2.0__react@18.3.1/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
